import { useTranslation } from 'react-i18next';

import { GlassCardLabel, GlassCard } from '@app/shared/ui/atoms/Home';
import { Cards } from '@app/shared/ui/molecules/Home/Cards';

export function TopCard() {
  const { t } = useTranslation();

  return (
    <GlassCard className="flex h-[53px] w-[72px] items-end justify-center p-1.5 pb-0.5">
      <Cards className="top-0 left-0" />
      <GlassCardLabel className="relative">{t('home.card')}</GlassCardLabel>
    </GlassCard>
  );
}
